export interface AppSpecInteractionContract {
  actionFlowRequired: boolean
  requiredEventTypes: string[]
  requiredStateScopes: string[]
  requireResultsTrace: boolean
  requireComputedProjection: boolean
  notes: string[]
}

export function createDefaultAppSpecInteractionContract(): AppSpecInteractionContract {
  return {
    actionFlowRequired: true,
    requiredEventTypes: ['change', 'tap'],
    requiredStateScopes: ['local', 'appData'],
    requireResultsTrace: true,
    requireComputedProjection: true,
    notes: [
      'Generated Coogo JSON must include declared events.bindings and flow.flows for user input events.',
      'Preview execution must update local state and appData, expose _results names, and reflect computed text in the renderer.',
    ],
  }
}
